document.body.addEventListener('foundVariation', (event) => {
    const variation = event.detail.variation;
    window.custom = window.custom || {};
    window.custom.selectedVariant = variation;
});

// Line-item properties for the add, set by snippets/product-custom-form.liquid:
// { 'Pre-order': 'Shipped in a month' } while the variant sells as a pre-order, else {}.
// Sent with the add so the pre-order promise shows in the cart, checkout and the order.
function phlLineProperties() {
    const props = window.phlPreorderProps;
    return props && typeof props === 'object' ? { ...props } : {};
}

document.addEventListener('click', async (e) => {
    if (!window.location.pathname.includes('/products')) return;

    const atcBtn = e.target.closest('#customaddtocart');
    const buyBtn = e.target.closest('#custombuynow');
    if (!atcBtn && !buyBtn) return;

    const variation = window.custom?.selectedVariant;
    if (!variation) return CartToast.show('This variant is out of stock.', 'error');

    if (atcBtn) {
        if (!variation.available) return CartToast.show('This variant is out of stock.', 'error');

        atcBtn.classList.add('is-loading');
        atcBtn.disabled = true;

        // Open the drawer on tap (it shows its loading state) instead of after the
        // add round trip, so the button responds instantly on slow mobile networks.
        const drawer = window.cartDrawer;
        drawer?.open();

        try {
            const cart = await drawer?.addItem(variation.id, 1, phlLineProperties());
            if (!cart) drawer?.close();
        } finally {
            atcBtn.classList.remove('is-loading');
            atcBtn.disabled = false;
        }
    }

    if (buyBtn) {
        e.preventDefault();
        if (!variation.available) return;

        buyBtn.classList.add('is-loading');
        buyBtn.disabled = true;

        try {
            const root = window.Shopify?.routes?.root ?? '/';

            await fetch(root + 'cart/clear.js', {
                method: 'POST'
            });

            const result = await window.cartDrawer?._request('cart/add.js', {
                items: [{
                    id: variation.id,
                    quantity: 1,
                    properties: phlLineProperties()
                }]
            });

            if (result) window.location.href = root + 'checkout';

        } catch (err) {
            CartToast.show(err.message || 'Something went wrong.', 'error');
            buyBtn.classList.remove('is-loading');
            buyBtn.disabled = false;
        }
    }
});
